/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The strings used for capabilities.
 */
export const CAPABILITY_STRINGS = {
  dialogIntro: `You don't currently have access to {{altTitle}}. Contact customer success to add this to your subscription or contact your organization owner to get access.`,
};

/**
 * The strings used for the Administration capability.
 */
export const ADMIN_CAPABILITY_STRINGS = {
  altTitle: `administration`,
  dialogBlurb: `gives you control over your subscription, users, and organization settings.`,
  dialogBullet1: `View your subscription status and product usage.`,
  dialogBullet2: `Access financial management functions.`,
  dialogBullet3: `Manage user role access.`,
  subtitle: `Manage users, roles, permissions, and monitor usage.`,
  title: `Administration`,
};

/**
 * The strings used for the Advanced Forms capability.
 */
export const ADVANCED_FORMS_CAPABILITY_STRINGS = {
  altTitle: `advanced forms`,
  dialogBlurb: `empowers non-technical users to easily create, update and manage forms for their organizations.`,
  dialogBullet1: `Create and update forms in minutes through an intuitive user interface.`,
  dialogBullet2: `Use the built-in analytics and reporting tools to collect data and identify trends.`,
  dialogBullet3: `Support ad-hoc campaigns and other business initiatives with bespoke forms.`,
  subtitle: `Build and manage basic or dynamic forms.`,
  title: `Advanced forms`,
};

/**
 * The strings used for the Content Management capability.
 */
export const CONTENT_CAPABILITY_STRINGS = {
  altTitle: `content management`,
  dialogBlurb: `is a low-code content management solution for large, non-technical teams.`,
  dialogBullet1: `Create and edit content easily.`,
  dialogBullet2: `Protect your brand by using content approval workflows.`,
  dialogBullet3: `Build pages faster using drag-and-drop components.`,
  productName: `Matrix CMS`,
  subtitle: `Build and manage websites, web pages, and more.`,
  title: `Content management`,
};

/**
 * The strings used for the Data Services capability.
 */
export const DATA_SERVICES_CAPABILITY_STRINGS = {
  altTitle: `data services`,
  dialogBlurb: `provides scalable, flexible, and configurable data services for advanced personalization.`,
  dialogBullet1: `Reduce the need to write backend code with customizable API blueprints.`,
  dialogBullet2: `Develop applications quickly with JavaScript SDK.`,
  dialogBullet3: `Rapidly build, test and deploy from your local machine.`,
  productName: `Datastore`,
  subtitle: `Store and serve data from any source for fast frontend interactions.`,
  title: `Data services`,
};

/**
 * The strings used for the Integrations capability.
 */
export const INTEGRATIONS_CAPABILITY_STRINGS = {
  altTitle: `integrations`,
  dialogBlurb: `is an integration platform to connect your systems, data and content together.`,
  dialogBullet1: `Build integrations faster using templates.`,
  dialogBullet2: `Integrate your favorite services.`,
  dialogBullet3: `Use workflows to automate processes.`,
  productName: `Connect`,
  subtitle: `Create and manage integrations with Squiz or third party services.`,
  title: `Integrations`,
};

/**
 * The strings used for the Search capability.
 */
export const SEARCH_CAPABILITY_STRINGS = {
  altTitle: `search`,
  dialogBlurb: `is a lightning-fast website search from any source and in any format.`,
  dialogBullet1: `Define how results rank based on keyword, location or timeframe.`,
  dialogBullet2: `Deploy search in your website quickly with pre-built templates and best-practice components.`,
  dialogBullet3: `Delight your users with real-time keyword suggestions as they type.`,
  productName: `Funnelback`,
  subtitle: `Index content from any source and manage search results.`,
  title: `Search`,
};
